import React, { useState } from "react";
import Data from "../recipeData";

const Buttons = ({ filterItem, setItem, menuItems }) => {
  const [appState, changeState] = useState({
    activeObject:null,
    objects:[{id:0}, {id:1}, {id:2}, {id:3}, {id:4}]
  })

  function toggleActive(id){
    changeState({...appState, activeObject:appState.objects[id]});
  }

  function toggleActiveStyle(id){
     if (appState.objects[id] === appState.activeObject){
        return "btn-highlight"
     }else{
      return "btn-normal"
     }
  }

  return (
    <>
      <div className="video-nav">
        <ul>
        <li
          // className={toggleActiveStyle(4)}
          //className={"btn-highlight " + ((appState.objects[4] === appState.activeObject) ? 'tn-normal-two' : 'btn-normal')}
          onClick={() => {setItem(Data); toggleActive(4)}}
          data-id="4">
          All
        </li>
        {menuItems.map((Val, id) => {
          return (
            <li className={toggleActiveStyle(id)}
            onClick={() => {filterItem(Val); toggleActive(id)}}
            key={id}
            data-id={id}
          >
            {Val}
          </li>
          );
        })}

        </ul>
      </div>
    </>
  );
};

export default Buttons;
